import React, { FC } from 'react';
import { Typography } from '@mui/material';
import { RouterLink } from './RouterLink';

type Props = {
  failedMessage?: string;
  emailSubject: string;
};

export const FailedMessageWithHref: FC<Props> = ({
  failedMessage,
  emailSubject
}) => {
  const href = `mailto:support@joinpopp.com?subject=${emailSubject}`;

  return (
    <Typography variant="body2" mt={1}>
      {failedMessage ? `${failedMessage} ` : ''}
      <RouterLink to={href} target="_blank">
        Contact support
      </RouterLink>{' '}
      if the issue persists.
    </Typography>
  );
};
